<div class="row">
  <div class="col-md-7">
    <div class="form-group">
      <label for="">Color</label>
      <input
        type="text"
        name="nombre"
        id="nombre"
        [(ngModel)]="item.nombre"
        class="form-control"
        placeholder=""
        aria-describedby="helpId"
      />
      <small id="helpId" class="text-muted">Ingrese el nombre del color</small>
    </div>
  </div>
  <div class="col-md-4">
    <label for="">'</label>
    <div class="input-group">
      <input
        type="color"
        name="hex"
        id="hex"
        [(ngModel)]="item.hex"
        class="form-control"
        placeholder=""
        aria-describedby="helpId"
      />
      <span class="input-group-text" (click)="add()">
        <i class="fa fa-plus" aria-hidden="true"></i>
      </span>
    </div>
  </div>
  <div class="col-md-12">
    <table *ngIf="items.length > 0" class="table table-striped table-inverse">
      <thead class="thead-inverse">
        <tr>
          <th>Color</th>
          <th>Nombre</th>
          <th>Acción</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of items">
          <td scope="row" style="background-color: {{ item.hex }};">
            {{ item.hex }}
          </td>
          <td>
            {{ item.nombre }}
          </td>
          <td>
            <button (click)="remove(item)" type="button" class="btn btn-danger">
              <i class="fa fa-minus" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
